// services/historyService.js

import { authConfig } from "../apiConfig";
//perPage = 10
export const fetchHistoryData = async (type, id,) => {
    try {
        let endpoint = "";
        let params = {};

        switch (type) {
            case "project":
                endpoint = "getProjectHistory";
                params = { projectID: id };
                break;
            case "worksite":
                endpoint = "getWorksiteHistory";
                params = { worksiteID: id };
                break;
            case "schedule":
                endpoint = "getScheduleHistory";
                params = { scheduleID: id, }; //per_page: perPage
                break;
            case "equipment":
                endpoint = "getEquipmentHistory";
                params = { equipmentID: id, };
                break;
            case "workforce":
                endpoint = "getWorkforceHistory";
                params = { workforceID: id, };
                break;
            case "invoice":
                endpoint = "getInvoicesHistoryList";
                params = { invoiceID: id, };
                break;
            default:
                throw new Error("Invalid history type");
        }

        const response = await authConfig.post(`/${endpoint}`, params);
        return response.data;
    } catch (error) {
        console.error(`Error fetching ${type} history:`, error);
        throw error;
    }
};
